export class ApiKeyAuthAuthentication {
    apiKey;
    constructor(apiKey) {
        this.apiKey = apiKey;
    }
    getName() {
        return "ApiKeyAuth";
    }
    applySecurityAuthentication(context) {
        context.setHeaderParam("Authorization", this.apiKey);
    }
}
export function configureAuthMethods(config) {
    let authMethods = {};
    if (!config) {
        return authMethods;
    }
    if (config["ApiKeyAuth"]) {
        authMethods["ApiKeyAuth"] = new ApiKeyAuthAuthentication(config["ApiKeyAuth"]);
    }
    return authMethods;
}
